import React from "react";
import styled from "styled-components";
import icons, { iconsData, } from "./icons";

const Icon = (props) => {
	const { style, ...p } = props;

	return (
		<Wrapper { ...p } style = { style } >
			<Picture
				{ ...p }
			/>
		</Wrapper>
	);
};

Icon.propTypes = {
	onClick: React.PropTypes.func,
	type: React.PropTypes.oneOf(icons).isRequired,
	size: React.PropTypes.oneOf([
		"xs",
		"sm",
		"md",
		"lg",
		"xl",
	]),
	color: React.PropTypes.string,
};

Icon.defaultProps = {
	size: "md",
};

const iconSizeMap = {
	xs: 15,
	sm: 20,
	md: 25,
	lg: 30,
	xl: 35,
};

const Wrapper = styled.div`
	position: relative;
	${p => p.onClick && `
		opacity: 0.33;
		transition: 0.1s linear all;
		cursor: pointer;

		&:hover {
			opacity: 0.66;
		}
	`}
	${p => (p.input || p.cm) && `
		position: absolute;
		bottom: 0;
		left: ${p.cm ? 0.5 : 0}em;
	`}	
`;

const Picture = styled.div`
	background: ${p => p.color || p.theme.black};
	mask-size: contain;
	mask-image: url(${p => require(`../img/icons/${iconsData[p.type].image}.svg`)});
	${p => (p.onClick || p.fauxButton || p.input || p.cm) && `
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -${iconSizeMap[p.size] * 0.5}px;
		margin-left: -${iconSizeMap[p.size] * 0.5}px;
	`}
`;

export default Icon;
